// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum RadarClassificationMode {
	Length = 0,
	Learned = 1,
}

export const RadarClassificationModeDisplayNames: { [key in keyof typeof RadarClassificationMode]?: string} = {
	"Length": "Length",
	0 : "Length",
	"Learned": "Learned",
	1 : "Learned",
}

export const getRadarClassificationModeDisplayName = (key: RadarClassificationMode | (keyof typeof RadarClassificationMode & string)) => {
	return RadarClassificationModeDisplayNames[key];
}

